import { Configuration } from "../generated/pdf";

export function getApiConfig(language?: string ) {
    
    // todo: token
    const token = "";
    
    if (!process.env.REACT_APP_API_PDFSERVICE) {
        throw new Error('process.env.REACT_APP_API_PDFSERVICE is not defined')
    }
    let url = process.env.REACT_APP_API_PDFSERVICE
    if (language) {
        const headers = {
            'Accept-Language': language,
        }
        return new Configuration({ basePath: url, accessToken: token, headers })
    }
    return new Configuration({ basePath: url, accessToken: token })
}
